import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(2),
    boxShadow: "10px 15px 50px rgba(0, 0, 0, 0.25)",
    borderRadius: 10,
  },
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  googleButton: {
    marginBottom: theme.spacing(2),
  },
  switchMode: {
    backgroundColor: "#343d48",
    border: "none",
    borderRadius: "20px",
    padding: "6px 15px",
    color: "white",
    cursor: "pointer",
    boxShadow: "5px 6px 10px rgba(0, 0, 0, 0.25)",
    transition: "all 0.4s ease-in-out",
    "&:hover": {
      webkitTransform: "translate(5px, -10px)",
      msTransform: "translate(10px, -10px)",
      transform: "translate(5px, -5px)",
      webkitBoxShadow: "0 20px 40px rgba(0, 0, 0, 0.08)",
      boxShadow: "10 20px 40px rgba(0, 0, 0, 0.08)",
    },
  },
}));
